import React, { useEffect, useContext } from 'react'
import { AcademyContext } from '../../../../Context/AcademyContext/AcademyContext'
import { EvCon } from './styles'
import { AcademyEventCard } from './AcademyEventCard'
import { Head3 } from '../../../../Components/Typography/Text.styles'
import { SlideDownFade } from '../../../../Components/Layout/Animations/SlideDownFade'
import { Loading } from '../../../Loading'
export const AcademyEventRows: React.FC = () => {
  const { filteredList, loading } = useContext(AcademyContext)!

  useEffect(() => {
    if (loading) {
      return
    }
  }, [filteredList, loading])

  if (loading) {
    return <Loading />
  }

  return (
    <SlideDownFade>
      <EvCon>
        {filteredList.length > 0 &&
          filteredList.map((ev) => <AcademyEventCard key={ev.academyEventId} ev={ev} />)}
        {filteredList.length < 1 && (
          <Head3>Currently no training events. Try reseting the filters.</Head3>
        )}
      </EvCon>
    </SlideDownFade>
  )
}
